import { type RouterInputs, api } from "@/components/TRPCProvider"
import * as React from "react"

export function useActivity(data?: RouterInputs["activity"]["create"] | null | false) {
  const currentData = React.useRef<RouterInputs["activity"]["create"]>(undefined)
  const { mutate: createActivity } = api.activity.create.useMutation()

  React.useEffect(() => {
    if (
      !data ||
      (data.resourceId && currentData.current?.resourceId === data.resourceId) ||
      (data.resource && currentData.current?.resource === data.resource)
    )
      return

    currentData.current = data
    createActivity(data)
  }, [data])

  return createActivity
}
